
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-time-line',
      title: 'Same-Day Delivery',
      description: 'Fast and reliable delivery service across Dubai and the UAE, ensuring your operations never stop'
    },
    {
      icon: 'ri-award-line',
      title: 'Premium Quality',
      description: 'ISO-certified products from world-renowned manufacturers, guaranteeing superior performance and durability'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trusted Partner',
      description: '20+ years of proven reliability and excellence, serving clients across 40+ countries worldwide'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Round-the-clock technical support and customer service to address all your industrial component needs'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Reach',
      description: 'Strategic location in Dubai enables efficient supply chain management and worldwide distribution'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Best value for money with transparent pricing and flexible payment terms for all clients'
    }
  ];

  return (
    <section id="why-choose" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-blue-600">Suncore International</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the difference with our commitment to excellence, reliability, and customer satisfaction
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group text-center p-8 rounded-2xl bg-gray-50 hover:bg-blue-50 transition-all duration-300 hover:shadow-lg hover:transform hover:scale-105"
            >
              <div className="w-16 h-16 bg-blue-100 group-hover:bg-blue-200 rounded-2xl flex items-center justify-center mx-auto mb-6 transition-colors">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-4 group-hover:text-blue-900">
                {feature.title}
              </h4>
              <p className="text-gray-600 group-hover:text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 lg:p-12 text-center text-white">
          <h4 className="text-3xl font-bold mb-4">
            Ready to Experience Excellence?
          </h4>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied clients who trust Suncore International for their industrial component needs
          </p>
        </div>
      </div>
    </section>
  );
}
